module.exports = __webpack_public_path__ + "static/img/dummy_potatoM.97065bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/side-menu/dummy_potatoM.png
// module id = 5lok
// module chunks = 1